import { KTSVG } from '_metronic/helpers'
import type { LineItem } from '../types'

interface Props {
  isView: boolean
  items: LineItem[]
  addItemRow: () => void
  removeItemRow: (id: string) => void
  updateItemRow: (id: string, field: keyof Omit<LineItem, 'id'>, value: string) => void
}

const ItemsTableSection: React.FC<Props> = ({
  isView,
  items,
  addItemRow,
  removeItemRow,
  updateItemRow,
}) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>รายการ</div>
          {!isView && (
            <div className='card-toolbar'>
              <button type='button' className='btn btn-sm btn-light-primary fw-bold' onClick={addItemRow}>
                เพิ่มแถว
              </button>
            </div>
          )}
        </div>
        <div className='card-body'>
          <div className='table-responsive'>
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-2'>
              <thead>
                <tr className='fw-bold text-gray-800'>
                  <th className='min-w-60px'>ที่</th>
                  <th className='min-w-200px'>รายการ</th>
                  <th className='min-w-150px'>ชนิด/แบบ</th>
                  <th className='min-w-100px'>จำนวน</th>
                  {!isView && <th className='w-50px' />}
                </tr>
              </thead>
              <tbody>
                {items.map((row, index) => (
                  <tr key={row.id}>
                    <td>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        value={row.no}
                        disabled={isView}
                        placeholder={String(index + 1)}
                        onChange={e => updateItemRow(row.id, 'no', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        value={row.description}
                        disabled={isView}
                        onChange={e => updateItemRow(row.id, 'description', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        value={row.typeModel}
                        disabled={isView}
                        onChange={e => updateItemRow(row.id, 'typeModel', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        value={row.quantity}
                        disabled={isView}
                        onChange={e => updateItemRow(row.id, 'quantity', e.target.value)}
                      />
                    </td>
                    {!isView && (
                      <td className='text-end'>
                        <button
                          type='button'
                          className='btn btn-sm btn-icon btn-light-danger'
                          onClick={() => removeItemRow(row.id)}
                          disabled={items.length <= 1}>
                          <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-1' />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ItemsTableSection
